// extracted by mini-css-extract-plugin
module.exports = {"moreButton":"_3s9So","openButton":"erJ7S","arrow":"Pu92i","arrowUp":"_1zbYI","actionText":"_23pts","preLabel":"_34GeE"};